import { useLocation } from 'react-router';
import styled, { withTheme } from 'styled-components';

import Icon from './Icon';

const IconButtonWrapper = styled.a`
  display: block;
  cursor: pointer;
`;

const IconTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

const IconButton = (props) => {
  const { theme, ...otherProps } = props;
  const location = useLocation();

  return (
    <IconButtonWrapper
      className={`icon-button pr-0 ${location.pathname.includes(props.href) && 'active'}`}
      {...otherProps}
    >
      <IconTextWrapper>
        <div className="svgHolder">
          <Icon colour={theme.colors.light} icon={props.icon} />
        </div>
        <div>{props.label}</div>
      </IconTextWrapper>
    </IconButtonWrapper>
  );
};

export default withTheme(IconButton);
